import { isPlatformBrowser } from '@angular/common';
import { DOCUMENT, inject, Injector, PLATFORM_ID } from '@angular/core';

import { CategoryModel, LocaleModel, MerchantModel, ProductModel, StoreModel, TemplateConfigurationModel } from '@accesso/cc-ui/model';
import { JsonApiService } from '@accesso/ng-json-api';

import { EntityName } from '../enums/entity';

interface NgStateCachedRequest {
	b?: {
		data: unknown;
		included: unknown[];
	};

	s?: number;
	st?: 'OK' | 'ER';
	u?: string;
}

const entityMap = {
	[EntityName.CATEGORY]: CategoryModel,
	[EntityName.LOCALE]: LocaleModel,
	[EntityName.MERCHANT]: MerchantModel,
	[EntityName.PRODUCT]: ProductModel,
	[EntityName.STORE]: StoreModel,
	[EntityName.TEMPLATE_CONFIGURATION]: TemplateConfigurationModel,
} as const;

const addEntity = (injector: Injector, jsonApi: JsonApiService, item?: Record<string, unknown>) => {
	if (!item?.['type'] || !item?.['id']) return;
	const Entity = entityMap[item['type'] as keyof typeof entityMap];
	if (!Entity) return;

	const ref = new Entity(injector, item['id'] as string);
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	ref.from(item as any);
	jsonApi.addEntity(Entity, ref);
};

export const jsonApiHydrationInitializer = () => {
	const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
	if (!isBrowser) return;

	const document = inject(DOCUMENT);
	const jsonApi = inject(JsonApiService);
	const ngData = document.getElementById('ng-state')?.textContent;
	if (!ngData) return;

	const injector = inject(Injector);

	try {
		(Object.values(JSON.parse(ngData)) as NgStateCachedRequest[]).forEach((value: NgStateCachedRequest) => {
			if (value?.s === 200 && value?.st === 'OK' && value?.b?.data) {
				const { data, included } = value.b;
				if (Array.isArray(data)) {
					data.forEach((item) => addEntity(injector, jsonApi, item));
				} else if (data) {
					addEntity(injector, jsonApi, data as unknown as Record<string, unknown>);
				}

				if (Array.isArray(included)) included.forEach((item) => addEntity(injector, jsonApi, item as unknown as Record<string, unknown>));
			}
		});
	} catch {
		/* ignore JSON parsing errors */
	}
};
